import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { InvoicePage } from '~/modules/billing/components/InvoicePage/components/InvoicePage';

interface ParamTypes {
  invoiceId: string;
}

export const Invoice = (): JSX.Element => {
  const { invoiceId } = useParams<ParamTypes>();
  const { t } = useTranslation('settings');

  return (
    <>
      <Helmet>
        <title>{t('account.billing.invoices.header')} - Shippo</title>
      </Helmet>
      <InvoicePage invoiceId={invoiceId} />
    </>
  );
};
